"use client";

import { motion } from "framer-motion";
import { Lightbulb, BookOpenCheck, Users, Sparkles } from "lucide-react";

const teachingPoints = [
  {
    id: 1,
    title: "Learning With Joy",
    description:
      "We make every lesson interactive and enjoyable to keep children curious, confident, and excited to learn.",
    icon: Sparkles,
    gradient: "from-orange-400 to-yellow-500",
  },
  {
    id: 2,
    title: "Activity-Based Teaching",
    description:
      "Children learn by doing through experiments, stories, games, role-plays, and hands-on tasks.",
    icon: BookOpenCheck,
    gradient: "from-blue-400 to-blue-600",
  },
  {
    id: 3,
    title: "Individual Attention",
    description:
      "Every child learns differently. We ensure personal care, guidance, and support for every student.",
    icon: Users,
    gradient: "from-green-400 to-green-600",
  },
  {
    id: 4,
    title: "Value-Based Education",
    description:
      "We teach discipline, hard work, and humanity shaping responsible, kind, and future-ready individuals.",
    icon: Lightbulb,
    gradient: "from-purple-400 to-purple-600",
  },
];

export default function WeTeaches() {
  return (
    <section data-component-id="src/app/weteaches.tsx:43:4" data-component-path="src/app/weteaches.tsx" data-component-line="43" data-component-file="weteaches.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22w-full%20py-20%20sm%3Apy-28%20bg-gray-50%22%7D" className="w-full py-20 sm:py-28 bg-gray-50">
      <div data-component-id="src/app/weteaches.tsx:44:6" data-component-path="src/app/weteaches.tsx" data-component-line="44" data-component-file="weteaches.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-%5B1400px%5D%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-8%22%7D" className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">

        {/* Heading */}
        <motion.div data-component-id="src/app/weteaches.tsx:47:8" data-component-path="src/app/weteaches.tsx" data-component-line="47" data-component-file="weteaches.tsx" data-component-name="motion.div" data-component-content="%7B%22elementName%22%3A%22motion.div%22%2C%22className%22%3A%22text-center%20mb-14%22%7D"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <h2 data-component-id="src/app/weteaches.tsx:54:10" data-component-path="src/app/weteaches.tsx" data-component-line="54" data-component-file="weteaches.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B26px%5D%20sm%3Atext-%5B48px%5D%20font-extrabold%20text-gray-800%22%2C%22textContent%22%3A%22How%20We%20Teach%22%7D" className="text-[26px] sm:text-[48px] font-extrabold text-gray-800">
            How We Teach  
          </h2>
          <p data-component-id="src/app/weteaches.tsx:57:10" data-component-path="src/app/weteaches.tsx" data-component-line="57" data-component-file="weteaches.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-%5B11px%5D%20sm%3Atext-%5B18px%5D%20text-gray-600%20max-w-%5B600px%5D%20mx-auto%20mt-3%22%2C%22textContent%22%3A%22Our%20modern%20teaching%20approach%20blends%20creativity%2C%20discipline%2C%20and%20joyful%20learning%5Cn%20%20%20%20%20%20%20%20%20%20%20%20to%20build%20confident%20and%20future-ready%20children.%22%7D" className="text-[11px] sm:text-[18px] text-gray-600 max-w-[600px] mx-auto mt-3">
            Our modern teaching approach blends creativity, discipline, and joyful learning
            to build confident and future-ready children.
          </p>
        </motion.div>

        {/* Teaching Cards */}
        <div data-component-id="src/app/weteaches.tsx:64:8" data-component-path="src/app/weteaches.tsx" data-component-line="64" data-component-file="weteaches.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22%5Cn%20%20%20%20%20%20%20%20%20%20grid%20grid-cols-1%20sm%3Agrid-cols-2%20lg%3Agrid-cols-4%20%5Cn%20%20%20%20%20%20%20%20%20%20gap-6%20sm%3Agap-8%5Cn%20%20%20%20%20%20%20%20%22%7D" className="
          grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 
          gap-6 sm:gap-8
        ">
          {teachingPoints.map((item, index) => {
            const Icon = item.icon;

            return (
              <motion.div data-component-id="src/app/weteaches.tsx:72:14" data-component-path="src/app/weteaches.tsx" data-component-line="72" data-component-file="weteaches.tsx" data-component-name="motion.div" data-component-content="%7B%22elementName%22%3A%22motion.div%22%2C%22className%22%3A%22%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20bg-white%20rounded-2xl%20p-6%20sm%3Ap-8%20shadow-md%20hover%3Ashadow-xl%20%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20border%20border-gray-100%20transition-all%20cursor-pointer%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%22%7D"
                key={item.id}
                initial={{ opacity: 0, y: 30, scale: 0.9 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.15 }}
                whileHover={{ scale: 1.05, rotate: 0 }}
                className="
                  bg-white rounded-2xl p-6 sm:p-8 shadow-md hover:shadow-xl 
                  border border-gray-100 transition-all cursor-pointer
                "
              >
                {/* Icon Box */}
                <motion.div data-component-id="src/app/weteaches.tsx:85:16" data-component-path="src/app/weteaches.tsx" data-component-line="85" data-component-file="weteaches.tsx" data-component-name="motion.div" data-component-content="%7B%22elementName%22%3A%22motion.div%22%7D"
                  whileHover={{ scale: 1.2, rotate: 8 }}
                  className={`
                    w-14 h-14 sm:w-16 sm:h-16 
                    rounded-2xl flex items-center justify-center 
                    text-white mb-5 shadow-lg
                    bg-gradient-to-br ${item.gradient}
                  `}
                >
                  <Icon data-component-id="src/app/weteaches.tsx:94:18" data-component-path="src/app/weteaches.tsx" data-component-line="94" data-component-file="weteaches.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22className%22%3A%22w-8%20h-8%22%7D" className="w-8 h-8" />
                </motion.div>

                {/* Title */}
                <h3 data-component-id="src/app/weteaches.tsx:98:16" data-component-path="src/app/weteaches.tsx" data-component-line="98" data-component-file="weteaches.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-%5B16px%5D%20sm%3Atext-%5B22px%5D%20font-bold%20text-gray-800%22%7D" className="text-[16px] sm:text-[22px] font-bold text-gray-800">
                  {item.title}
                </h3>

                {/* Description */}
                <p data-component-id="src/app/weteaches.tsx:103:16" data-component-path="src/app/weteaches.tsx" data-component-line="103" data-component-file="weteaches.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-%5B11px%5D%20sm%3Atext-%5B16px%5D%20text-gray-600%20mt-2%20leading-relaxed%22%7D" className="text-[11px] sm:text-[16px] text-gray-600 mt-2 leading-relaxed">
                  {item.description}
                </p>
              </motion.div>
            );
          })}
        </div>

        {/* Bottom Highlight Block */}
        <motion.div data-component-id="src/app/weteaches.tsx:112:8" data-component-path="src/app/weteaches.tsx" data-component-line="112" data-component-file="weteaches.tsx" data-component-name="motion.div" data-component-content="%7B%22elementName%22%3A%22motion.div%22%2C%22className%22%3A%22mt-16%20sm%3Amt-20%22%7D"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mt-16 sm:mt-20"
        >
          <div data-component-id="src/app/weteaches.tsx:119:10" data-component-path="src/app/weteaches.tsx" data-component-line="119" data-component-file="weteaches.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20bg-gradient-to-r%20from-%5B%23f6a532%5D%20to-orange-500%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20text-white%20rounded-3xl%20p-8%20sm%3Ap-12%20shadow-xl%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20text-center%20max-w-%5B900px%5D%20mx-auto%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%22%7D"
            className="
              bg-gradient-to-r from-[#f6a532] to-orange-500
              text-white rounded-3xl p-8 sm:p-12 shadow-xl
              text-center max-w-[900px] mx-auto
            "
          >
            <h3 data-component-id="src/app/weteaches.tsx:126:12" data-component-path="src/app/weteaches.tsx" data-component-line="126" data-component-file="weteaches.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-%5B20px%5D%20sm%3Atext-%5B32px%5D%20font-extrabold%20mb-3%22%2C%22textContent%22%3A%22We%20Teach%20With%20Heart%20%26%20Vision%22%7D" className="text-[20px] sm:text-[32px] font-extrabold mb-3">
              We Teach With Heart & Vision
            </h3>
            <p data-component-id="src/app/weteaches.tsx:129:12" data-component-path="src/app/weteaches.tsx" data-component-line="129" data-component-file="weteaches.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-%5B11px%5D%20sm%3Atext-%5B18px%5D%20leading-relaxed%22%2C%22textContent%22%3A%22We%20believe%20education%20must%20build%20knowledge%2C%20values%2C%20creativity%2C%20and%20confidence.%20%20%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20Our%20mission%20is%20to%20create%20a%20joyful%20learning%20space%20where%20every%20child%20shines.%22%7D" className="text-[11px] sm:text-[18px] leading-relaxed">
              We believe education must build knowledge, values, creativity, and confidence.  
              Our mission is to create a joyful learning space where every child shines.
            </p>
          </div>
        </motion.div>

      </div>
    </section>
  );
}
